wbApp.controller('PreviewHoursSucessSummaryCtrl', ['$scope', '$translate', '$timeout', 'previewHoursSvc',
function ($scope, $translate, $timeout, previewHoursSvc) {

    $scope.fromDate = moment().subtract(6, 'months').toDate();
    $scope.toDate = moment().add(1, 'day').toDate();

    $scope.stats = [];
    var isActive = false;
    var loaded = false;

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActive) {
                isActive = true;
                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    function loadData() {
        if ($scope.fromDate && $scope.toDate) {
            $scope.stats = previewHoursSvc.getPreviewHoursSuccessStats($scope.fromDate, $scope.toDate);
            $scope.stats.$promise.then(function(data)
            {
                $scope.previewHoursSuccessGraph.data = 
                    previewHoursSvc.getPreviewHoursSuccessGraph(data);
            })
        } else 
        {
            $scope.stats = [];
            $scope.previewHoursSuccessGraph.data = 
                previewHoursSvc.getPreviewHoursSuccessGraph([]);
        }
    }


    $scope.onDateRangeChanged = function () {
        loadData();
    }
 
    $scope.previewHoursSuccessGraph = {
        type: 'BarChart',
        data: previewHoursSvc.getPreviewHoursSuccessGraph([]),
        options: {
            displayExactValues: true,            
            chartArea: { width: '90%', height: '70%' },
            legend: {
                position: 'top'
            },
            vAxis: {},
            hAxis: {},
            orientation: 'horizontal'
        }
    };


    $scope.previewHoursSuccessStatsGridSettings = {
        name: 'previewHoursSuccessStat',
        columns: [
            { dataField: 'reference', caption: $translate.instant("TXT_LBL_REFERENCE"), dataType: 'string' },
            { dataField: 'noOfPreviewHours', caption: $translate.instant('TXT_PREVIEW_HOURS'), dataType: 'number', width: '70px' },
            { dataField: 'noOfRegistrationsInTheSameSemester', caption: $translate.instant('TXT_SAME_SEMESTER'), dataType: 'number', width: '70px' },
            { dataField: 'noOfRegistrationsInAnySemester', caption: $translate.instant('TXT_ANY_TIME'), dataType: 'number', width: '70px' },
        ]
    };

}]);